/*
 * Copyright (c) 2020. American Express Company
 */

import { LocalDate } from '@js-joda/core';
import DateUtils from 'src/utils/date';

export class IncomeSourceModel {
    incomeUid: string;
    id?: string; // added by frontend to use for filter display
    startDate?: LocalDate;
    endDate?: LocalDate;
    name?: string;
    annualizedIncome: number;
    events: any[];
    frequency: string;
    userCreated: boolean;
    startedByCardId?: number;

    public static dateify(incomeSource: IncomeSourceModel): IncomeSourceModel {
        return {
            ...incomeSource,
            startDate: DateUtils.dateify(incomeSource.startDate),
            endDate: DateUtils.dateify(incomeSource.endDate)
        };
    }
}

export interface TransactionIncomeSourceValueModel {
    [incomeUid: string]: number;
}

export interface ClickAddIncomeSourceModel {
    name: string;
    onClick?: () => void;
}
